
import { CostsPerEmployeeType } from "./cost-per-employee-type";

export class CostsPerEmployee {

    id: number = 0;
    description!: string;
    costsPerEmployeeType: CostsPerEmployeeType = new CostsPerEmployeeType();
    attribute!: string;
    active: boolean = false;
} 